module.exports = __webpack_public_path__ + "static/media/referez_ami_site.9b2d5c6b.gif";